import "./style.css";

import Player from "@vimeo/player";

export default class HomeAnimation {
  static selector = ".home-animation";

  constructor(block) {
    this.block = block;

    this.vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    this.vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    this.url = window.location.protocol + "//" + window.location.host;

    this.banner = this.block;
    this.copy = this.block.querySelector(".home-animation__copy");
    this.firstHeading = this.block.querySelector(
      ".home-animation__copy__titles > div > h1"
    );
    this.firstButton = this.block.querySelector(
      ".home-animation__copy__titles--single--button"
    );

    this.secondHeading = this.block.querySelectorAll(
      ".home-animation__copy__titles--single"
    )[1];

    this.illustration = this.block.querySelector(
      ".home-animation__illustration-wrapper"
    );

    this.homeVideo = this.block.querySelector(".home-animation iframe");
    this.playButton = this.block.querySelector(
      ".home-animation__copy__play-button"
    );

    this.playButton.addEventListener("click", this.expandBanner);
    this.player = new Player(this.homeVideo);
    this.player.on("ended", this.hideVideo);

    this.bannerHeight = this.vw >= 1280 && this.vh <= 612 ? "33rem" : "45rem";

    this.expanded;
    this.isPlaying;
  }

  playVideo = () => {
    this.isPlaying = true;
    this.block.classList.add("black");
    this.player.play();
  };

  expandBanner = () => {
    this.vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );
    this.banner.style.height = `${this.vh - 63}px`;

    this.copy.style.opacity = 0;
    this.illustration.style.opacity = 0;
    this.expanded = true;
    this.banner.addEventListener("transitionend", this.showVideo);
  };

  showVideo = (event) => {
    if (event.propertyName == "height" && this.expanded == true) {
      this.copy.style.transform = "translateY(50%)";
      this.homeVideo.style.visibility = "visible";
      this.homeVideo.style.opacity = 1;

      this.playVideo();
    }
  };

  hideVideo = () => {
    this.setCookie("videoWatched", "true");
    this.homeVideo.style.opacity = 0;
    this.isPlaying = false;
    this.homeVideo.addEventListener("transitionend", this.shrinkBanner);
  };

  shrinkBanner = (event) => {
    if (event.propertyName == "opacity" && !this.isPlaying) {
      // reset player to its original state
      this.player.unload();
      this.block.classList.remove("black");
      this.homeVideo.style.visibility = "hidden";
      this.banner.style.height = this.bannerHeight;
      this.illustration.style.opacity = 1;
      this.expanded = false;
      this.firstHeading.classList.remove("initial-copy");
      this.illustration.addEventListener("transitionend", this.updateCopy);
    }
  };

  updateCopy = (event) => {
    if (event.propertyName == "opacity" && !this.expanded) {
      this.copy.style.opacity = 1;
      this.copy.style.transform = "translateY(0%)";
      this.firstHeading.innerHTML =
        window.backendVars.copy["Learn more about CCE"];
      this.firstButton.classList.remove("hidden");
      this.secondHeading.classList.remove("hidden");
    }
  };

  setCookie(cname, cvalue) {
    document.cookie = cname + "=" + cvalue + ";" + ";path=/";
  }
}
